import { escapeAttributeValue } from '../../data_table/dom';
import { watchlistGridClasses as c } from './watchlistGridStyles';

// Drops widths outside the interquartile fences, so one unusually long value
// does not stretch the whole column.
function excludeOutliers(values, factor = 1.5) {
    if (values.length < 4) return values;
    const sorted = values.slice().sort((left, right) => left - right);
    const q1 = sorted[Math.floor(sorted.length * 0.25)];
    const q3 = sorted[Math.floor(sorted.length * 0.75) - 1];
    const iqr = q3 - q1;
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return sorted.filter((value) => value > q1 - deviation && value < q3 + deviation);
}

// Double-click autosize: the widest rendered cell (outliers excluded) or the
// header content, clamped to the column limits. Runs synchronously inside the
// double-click handler.
export function measureColumnContentWidth(root, field, { minWidth = 0, maxWidth = Infinity } = {}) {
    const fieldSelector = `[data-field="${escapeAttributeValue(field)}"]`;
    root.classList.add(c.autosizing);
    try {
        const cells = root.querySelectorAll(`.${c.body} [role="gridcell"]${fieldSelector}`);
        const widths = excludeOutliers(
            Array.from(cells, (cell) => cell.getBoundingClientRect().width || 0),
        );
        const header = root.querySelector(`[role="columnheader"]${fieldSelector}`);
        if (header) {
            // The whole title area, so controls a header function puts next
            // to its label (a filter button) count too.
            const title = header.querySelector(`.${c.headerTitleContent}`);
            const iconContainer = header.querySelector(`.${c.headerIconContainer}`);
            const menu = header.querySelector(`.${c.headerMenu}`);
            const style = window.getComputedStyle(header);
            const padding = (parseInt(style.paddingLeft, 10) || 0)
                + (parseInt(style.paddingRight, 10) || 0);
            widths.push(
                (title ? title.scrollWidth + 1 : 0)
                + padding
                + (iconContainer?.clientWidth || 0)
                + (menu?.clientWidth || 0),
            );
        }
        const contentWidth = widths.length ? Math.max(...widths) : 0;
        return Math.min(Math.max(contentWidth, minWidth), maxWidth);
    } finally {
        root.classList.remove(c.autosizing);
    }
}
